import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnitClass;
function Unit() {
  if (UnitClass === VOID) {
    class $ {
      toString() {
        return 'kotlin.Unit';
      }
    }
    initMetadataForObject($, 'Unit');
    UnitClass = $;
  }
  return UnitClass;
}
var Unit_instance;
function Unit_getInstance() {
  return Unit_instance;
}
//region block: init
Unit_instance = new (Unit())();
//endregion
//region block: exports
export {
  Unit_instance as Unit_instance3kz1zqli6gr1r,
  Unit as Unitkvevlwgzwiuc,
};
//endregion

//# sourceMappingURL=Unit.mjs.map
